import React from 'react';
import WorkingBoss from 'components/Tvendo/Distribution/Operations/WorkingBoss/List';

export default function () {
  return <WorkingBoss />;
}
